export default __webpack_public_path__ + "static/media/delete-icon.2ce31230.svg";